import * as React from "react"
import ReactDOM from "react-dom"
import { DragSource, DropTarget } from "react-dnd-legacy"
import DragDataTableRow from "./DragDataTableRow"

const DragAndDropTableRowHover = (props: any) => {
    const { isDragging, didDrop, connectDragSource, connectDropTarget, dragRow, ...restProps } = props
    let className = restProps.className

    if (isDragging && !didDrop) {
        className += " draggedRow"
    }

    // Make all rows transparent during dragging anything
    // Fixes the antdesign table row hover keeps active during draging bug
    if (!didDrop && dragRow && dragRow.id !== props.id) {
        className += " nonDraggedRow"
    }

    return (
        <DragDataTableRow
            ref={instance => {
                connectDropTarget(ReactDOM.findDOMNode(instance)) // eslint-disable-line

                connectDragSource(ReactDOM.findDOMNode(instance)) // eslint-disable-line
            }}
            hoverRow={!didDrop && dragRow && dragRow.id === props.id}
            {...restProps}
            className={className}
        />
    )
}

// eslint-disable-next-line func-style
function dragDirection(dragIndex, hoverIndex, initialClientOffset, clientOffset, sourceClientOffset) {
    const hoverMiddleY = (initialClientOffset.y - sourceClientOffset.y) / 2
    const hoverClientY = clientOffset.y - sourceClientOffset.y

    if (hoverClientY > hoverMiddleY) {
        return "down"
    } else if (hoverClientY < hoverMiddleY) {
        return "up"
    }

    return null
}

const rowSource = {
    beginDrag: props => {
        return {
            id: props.id,
            index: props.index,
            parentId: props.parentId,
            onDropCallback: props.onDropCallback,
            onHoverCallback: props.onHoverCallback,
            canDropCallback: props.canDropCallback,
        }
    },
    isDragging: (props, monitor) => {
        return monitor.getItem().id === props.id
    },
}
const rowTarget = {
    hover: (props, monitor) => {
        if (props.onHoverCallback) {
            const monitorCopy = monitor
            const sourceId = monitor.getItem().id
            const sourceIndex = monitor.getItem().index
            const sourceParentId = monitor.getItem().parentId
            const targetId = props.id
            const targetIndex = props.index
            const targetParentId = props.parentId

            // Don't replace items with themselves
            if (sourceId === targetId) {
                return
            }

            const direction = dragDirection(
                monitor.getItem().index,
                props.index,
                monitor.getInitialClientOffset(),
                monitor.getClientOffset(),
                monitor.getSourceClientOffset()
            )
            const result = props.onHoverCallback(
                sourceIndex,
                targetIndex,
                sourceId,
                targetId,
                sourceParentId,
                targetParentId,
                direction
            )

            monitorCopy.getItem().index = result?.newIndex ?? targetIndex
            monitorCopy.getItem().parentId = result?.newParentId ?? null
        }
    },
    drop: (props, monitor) => {
        if (props.onDropCallback) {
            const sourceId = monitor.getItem().id
            const sourceIndex = monitor.getItem().index
            const targetId = props.id
            const targetIndex = props.index
            props.onDropCallback(sourceId, targetId, sourceIndex, targetIndex)
        }
    },
}

const connectTarget = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    didDrop: monitor.didDrop(),
    sourceClientOffset: monitor.getSourceClientOffset(),
})

const connectSource = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    didDrop: monitor.didDrop(),
    dragRow: monitor.getItem(),
    clientOffset: monitor.getClientOffset(),
    initialClientOffset: monitor.getInitialClientOffset(),
})

export default DropTarget(
    "row",
    rowTarget,
    connectTarget
)(DragSource("row", rowSource, connectSource)(DragAndDropTableRowHover))
